export default __webpack_public_path__ + "static/media/points.8bb6a174.svg";